import searchService from '@/services/search';
import moment from 'moment';
import router from '@/router.js';

export default {
  state: {
    isApp: window.navigator.userAgent === 'naprokat-mobile-client-ios' || window.navigator.userAgent === 'naprokat-mobile-client-android'  || false,
    isAuth: document.querySelector("meta[name='Bearer']").getAttribute('content').length > 0 || false,
    locationsStart: [],
    locationsEnd: [],
    locationStart: null,
    locationEnd: null,
    dateStart: null,
    dateEnd: null,
    timeStart: null,
    timeEnd: null,
    cars: null,
    car: null,
    variants: null,
    step: 1,
    category: [],
    isLocationChange: false,
    isCalendarChange: false,
    redirectScreen: false,
    emptyParameters: false,
    vendor: null,
    promocode: null,
    presets: null,
    loading: {
        locationsStart: true,
        locationsEnd: true,
        cars: true,
    },
    parameters: {
      pick_up_datetime: null,
      drop_off_datetime: null,
      pick_up_location_id: null,
      drop_off_location_id: null,
    },
  },
  getters: {
    isLocationChange: state => state.isLocationChange,
    isCalendarChange: state => state.isCalendarChange,
    locationsStart: state => state.locationsStart,
    locationsEnd: state => state.locationsEnd,
    locationStart: state => state.locationStart,
    locationEnd: state => state.locationEnd,
    dateStart: state => state.dateStart,
    dateEnd: state => state.dateEnd,
    timeStart: state => state.timeStart,
    timeEnd: state => state.timeEnd,
    locationsLoading: state => state.loading,
    cars: state => state.cars,
    car: state => state.car,
    step: state => state.step,
    category: state => state.category,
    parameters: state => state.parameters,
    redirectScreen: state => state.redirectScreen,
    emptyParameters: state => state.emptyParameters,
    isApp: state => state.isApp,
    variants: state => state.variants,
    isAuth: state => state.isAuth,
    promocode: state => state.promocode,
    presets: state => state.presets,
  },
  actions: {
    clearVendor({ commit }) {
        commit('clear_vendor');
    },
    clearVariants({ commit }) {
        commit('clear_variants');
    },
    setVariants({ commit }, car) {
        commit('set_variants', car);
    },
    setVendor({ commit }, vendor) {
        commit('set_vendor', vendor);
    },
    changeStartDateTime({ commit }, date) {
        commit('update_start_datetime', date);
    },
    changeEndDateTime({ commit }, date) {
        commit('update_end_datetime', date);
    },
    setSearchParameters({ commit }, parameters) {
        commit('set_parameters', parameters);
    },
    getPresets({ commit }) {
      return new Promise((resolve, reject) => {
        searchService.getPresets()
          .then((response) => {
            commit('set_presets', response.data);
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    getLocationsStart({ commit }) {
      commit('locationsstart_loading_start');
      return new Promise((resolve, reject) => {
        searchService.getLocationsStart()
          .then((response) => {
            commit('set_locations_start', response.data);
            commit('locationsstart_loading_finish');
            resolve();
          })
          .catch(() => {
            reject();
            commit('locationsstart_loading_finish');
          });
      });
    },
    getCars({ commit, state }) {
      commit('cars_loading_start');
        const parameters = {
          pick_up_datetime: state.parameters.pick_up_datetime,
          drop_off_datetime: state.parameters.drop_off_datetime,
          pick_up_location_id: state.parameters.pick_up_location_id,
          drop_off_location_id: state.parameters.drop_off_location_id,
          vendor: state.vendor,
          promocode: state.promocode,
        }
        if (!Object.values(parameters).every(o => o === null)) {
          if (state.category.length < 1) {
            return new Promise((resolve, reject) => {
              searchService.getCars(parameters)
                .then((response) => {
                  commit('set_cars', response.data);
                  resolve(response.data);
                  commit('cars_loading_finish');
                })
                .catch((error) => {
                  if (error.response && error.response.status === 422) {
                    commit('cars_loading_finish');
                    commit('clear_cars');
                  } 
                  reject(error);
                });
            });
          } else {
            let categories = state.category.map(function(el, idx) {
              return 'subcategories_ids[' + idx + ']=' + el;
            }).join('&');
            let pars = {
              pick_up_datetime: state.parameters.pick_up_datetime,
              drop_off_datetime: state.parameters.drop_off_datetime,
              pick_up_location_id: state.parameters.pick_up_location_id,
              drop_off_location_id: state.parameters.drop_off_location_id,
              vendor: state.vendor,
              category: categories,
              promocode: state.promocode,
            }
            return new Promise((resolve, reject) => {
              searchService.getCarsWithCat(pars)
                .then((response) => {
                  commit('set_cars', response.data);
                  resolve(response.data);
                  commit('cars_loading_finish');
                })
                .catch((error) => {
                  if (error.response && error.response.status === 422) {
                    commit('cars_loading_finish');
                    commit('clear_cars');
                  } 
                  reject(error);
                });
            });
          }
        } else {
          commit('cars_loading_finish');
        }
    },
    getLocationsEnd({ commit, state }) {
      commit('locationsend_loading_start');
      if (state.locationStart) {
          return new Promise((resolve, reject) => {
            searchService.getLocationsEnd(state.locationStart)
              .then((response) => {
                commit('set_locations_end', response.data);
                commit('locationsend_loading_finish');
                resolve();
              })
              .catch(() => {
                reject();
                commit('locationsend_loading_finish');
              });
          });
      }
    },
    setLocationStartById({ commit, state }, id) {
      let location = state.locationsStart.filter(location => location.id == id)[0];
      commit('set_location_start', location);
    },
    setLocationEndById({ commit, state }, id) {
      let location = state.locationsEnd.filter(location => location.id == id)[0];
      commit('set_location_end', location);
    },
    setLocationEnd({ commit }, location) {
        commit('set_location_end', location);
    },
    setLocationStart({ commit }, location) {
      if (location) {
        commit('set_location_start', location);
      }
    },
    setCar({ commit }, car) {
        commit('set_car', car);
    },
    clearLocationStart({ commit }) {
        commit('clear_location_start');
    },
    clearLocationEnd({ commit }) {
        commit('clear_location_end');
    },
    clearLocationsEnd({ commit }) {
        commit('clear_locations_end');
    },
    clearLocationsStart({ commit }) {
        commit('clear_locations_start');
    },
    clearCars({ commit }) {
        commit('clear_cars');
    },
    clearCar({ commit }) {
        commit('clear_car');
    },
    setLocationChange({ commit }, status) {
        commit('set_location_change', status);
    },
    setCalendarChange({ commit }, status) {
        commit('set_calendar_change', status);
    },
    setCarById({ commit, state }, id) {
      const car = state.cars.vehicles.filter((car) => {
        if (car.vehicle) {
         return car.vehicle.id == id;
        } else {
          let cc = car.vehicles.filter((c) => {
            return c.id == id
          })
          if (cc[0]) {
            return cc[0].id == id;
          } else {
            return false;
          }
        }
      });
      if (car[0].vehicle) {
        commit('set_car', car[0].vehicle);
      } else {
        let c = car[0].vehicles.filter(i => i.id == id)[0];
        commit('set_car', c);
      }
    },
    setCategory({ commit }, id) {
      commit('set_category', id);
    },
    setCategories({ commit }, cats) {
      commit('set_categories', cats);
    },
    removeCategory({ commit }, id) {
      commit('remove_category', id);
    },
    setStep({ commit }, step) {
      commit('set_step', step);
    },
    setRedirectScreen({ commit }) {
      commit('set_redirect');
    },
    setPromocode({ commit }, promocode) {
      commit('set_promocode', promocode);
    },
  },
  mutations: {
    set_parameters(state, parameters) {
      state.parameters = parameters;
      state.dateStart = moment(parameters.pick_up_datetime, 'YYYY-MM-DD HH:mm').format('DD.MM.YYYY');
      state.timeStart = moment(parameters.pick_up_datetime, 'YYYY-MM-DD HH:mm').format('HH:mm');
      state.dateEnd = moment(parameters.drop_off_datetime, 'YYYY-MM-DD HH:mm').format('DD.MM.YYYY');
      state.timeEnd = moment(parameters.drop_off_datetime, 'YYYY-MM-DD HH:mm').format('HH:mm');
    },
    update_start_datetime(state, date) {
      let dateStart = moment(date, 'DD.MM.YYYY HH:mm').format('DD.MM.YYYY');
      let timeStart = moment(date, 'DD.MM.YYYY HH:mm').format('HH:mm');
      let pick_up_datetime = moment(date, 'DD.MM.YYYY HH:mm').format('YYYY-MM-DD HH:mm');
      state.dateStart = dateStart;
      state.timeStart = timeStart;
      state.parameters.pick_up_datetime = pick_up_datetime;
    },
    update_end_datetime(state, date) {
      let dateEnd = moment(date, 'DD.MM.YYYY HH:mm').format('DD.MM.YYYY');
      let timeEnd = moment(date, 'DD.MM.YYYY HH:mm').format('HH:mm');
      let drop_off_datetime = moment(date, 'DD.MM.YYYY HH:mm').format('YYYY-MM-DD HH:mm');
      state.dateEnd = dateEnd;
      state.timeEnd = timeEnd;
      state.parameters.drop_off_datetime = drop_off_datetime;
    },
    set_cars(state, cars) {
      state.cars = cars;
    },
    clear_locations_end(state) {
      state.locationsEnd = [];
    },
    clear_locations_start(state) {
      state.locationsStart = [];
    },
    clear_cars(state) {
      state.cars = null;
    },
    clear_vendor(state) {
      state.vendor = null;
    },
    set_locations_start(state, locations) {
      state.locationsStart = locations;
    },
    set_location_start(state, location) {
      state.locationStart = location;
      state.parameters.pick_up_location_id = location.id;
    },
    set_location_end(state, location) {
      state.locationEnd = location;
      state.parameters.drop_off_location_id = location.id;
    },
    clear_location_end(state) {
      state.locationEnd = null;
      state.parameters.drop_off_location_id = null;
    },
    clear_location_start(state) {
      state.locationStart = null;
      state.parameters.pick_up_location_id = null;
    },
    set_locations_end(state, locations) {
      state.locationsEnd = locations;
    },
    cars_loading_start(state) {
      state.loading.cars = true;
    },
    cars_loading_finish(state) {
      state.loading.cars = false;
    },
    locationsstart_loading_start(state) {
      state.loading.locationsStart = true;
    },
    locationsstart_loading_finish(state) {
      state.loading.locationsStart = false;
    },
    locationsend_loading_start(state) {
      state.loading.locationsEnd = true;
    },
    locationsend_loading_finish(state) {
      state.loading.locationsEnd = false;
    },
    set_car(state, car) {
      state.car = car;
    },
    remove_category(state, id) {
      let index = state.category.indexOf(id);
      state.category.splice(index, 1);
    },
    set_category(state, id) {
      state.category.push(id);
    },
    set_categories(state, cats) {
      state.category = JSON.parse(cats);
    },
    clear_car(state) {
      state.car = null;
    },
    set_location_change(state, status) {
      state.isLocationChange = status;
    },
    set_calendar_change(state, status) {
      state.isCalendarChange = status;
    },
    set_redirect(state) {
      state.redirectScreen = true;
    },
    set_empty_parameters(state, status) {
      state.emptyParameters = status;
    },
    set_step(state, step) {
      state.step = step;
    },
    set_variants(state, car) {
      state.variants = car;
    },
    set_vendor(state, vendor) {
      state.vendor = vendor;
    },
    set_promocode(state, promocode) {
      state.promocode = promocode;
    },
    set_presets(state, presets) {
      state.presets = presets.presets;
    },
    clear_variants(state) {
      state.variants = null;
    },
  },
};
